import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Dropdown } from "primeng/dropdown";

import { DataService_itemcollection } from "../shared/data.service";
import { PersonSelectorService } from "../../../personselector/personselector.service";

import { wsItemCollectionStudentAddEditInfoParm } from "../shared/wsItemCollectionStudentAddEditInfo";
import { wsItemCollectionStudentAddEditInfo } from "../shared/wsItemCollectionStudentAddEditInfo";
import { ScanPersonalItemClassInfo } from "../shared/wsItemCollectionStudentAddEditInfo";
import { ScanPersonalItemConditionInfo } from "../shared/wsItemCollectionStudentAddEditInfo";

import { wsItemCollectionStudentAddEditUpdateInfoParm } from "../shared/wsItemCollectionStudentAddEditInfo";

@Component({
	selector: "app-root",
	templateUrl: "./itemcollectionaddedit.component.html",
	styleUrls: ["./itemcollectionaddedit.component.css"],
	providers: [ConfirmationService],
})
export class ItemCollectionAddEditComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_itemcollection,
		private personselectorService: PersonSelectorService,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isEditMode: boolean = false;

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any; // From Person Selector

	public ItemCollectionStudentAddEditInfo: wsItemCollectionStudentAddEditInfo =
	{
		ScanPersonalItemID: "",
		PersonID: -1,
		StudentID: "",
		FullName: "",
		Log_PersonID: -1,
		LogByFullName: "",
		ScanPersonalItemClassID: -1,
		ScanPersonalItemConditionID: -1,
		BinNumber: "",
		ScanPersonalItemDesc: "",
		CollectionDTDesc: "",
		Returned: "",
		ChangedByFullName: "",
		ChangedDTDesc: "",
		ScanPersonalItemClassItems: [],
		ScanPersonalItemConditionItems: []
	}; // For HTML to not error on init
		
	public lstScanPersonalItemClass: ScanPersonalItemClassInfo[] = [];
	public SelectedScanPersonalItemClass: ScanPersonalItemClassInfo = 
	{
		ScanPersonalItemClassID: -1,
		ScanPersonalItemClassDesc: "",
	}; // For HTML to not error on init

	public lstScanPersonalItemCondition: ScanPersonalItemConditionInfo[] = [];
	public SelectedScanPersonalItemCondition: ScanPersonalItemConditionInfo = {
		ScanPersonalItemConditionID: -1,
		ScanPersonalItemConditionDesc: "",
	}; // For HTML to not error on init

	//	Error Messaging
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
		});		

		let parm: wsItemCollectionStudentAddEditInfoParm = 
		{
			ScanPersonalItemID: this.dialogConfig.data.ScanPersonalItemID
		};		

		if (parm.ScanPersonalItemID.length == 0) 
		{	
			this.isEditMode = false;
		}
		else
		{
			this.isEditMode = true;
		}

		this.isBusy = true;
		this.dataService.ItemCollectionStudentAddEditGetData(parm).subscribe((data) => this.ItemCollectionStudentAddEditGetData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() 
	{
		this.subscriptionPersonSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStudentAddEditGetData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentAddEditGetData_Complete(data: any) {

		this.ItemCollectionStudentAddEditInfo = data;

		this.lstScanPersonalItemClass = this.ItemCollectionStudentAddEditInfo.ScanPersonalItemClassItems;
		this.lstScanPersonalItemCondition = this.ItemCollectionStudentAddEditInfo.ScanPersonalItemConditionItems;

		//
		//	Select Default ScanPersonalItemClass
		//
		this.SelectedScanPersonalItemClass = this.lstScanPersonalItemClass[0];

		this.lstScanPersonalItemClass.forEach((item) => {
			if (item.ScanPersonalItemClassID == this.ItemCollectionStudentAddEditInfo.ScanPersonalItemClassID) {
				this.SelectedScanPersonalItemClass = item;
			}
		});

		//
		//	Select Default ScanPersonalItemCondition
		//
		this.SelectedScanPersonalItemCondition = this.lstScanPersonalItemCondition[0];

		this.lstScanPersonalItemCondition.forEach((item) => {
			if (item.ScanPersonalItemConditionID == this.ItemCollectionStudentAddEditInfo.ScanPersonalItemConditionID) {
				this.SelectedScanPersonalItemCondition = item;
			}
		});

		//
		//	Are We in Add mode?
		//
		if (this.isEditMode == false)
		{
			this.ItemCollectionStudentAddEditInfo.Log_PersonID = this.dialogConfig.data.Log_PersonID;
			this.ItemCollectionStudentAddEditInfo.LogByFullName = this.dialogConfig.data.LogByFullName;
			this.ItemCollectionStudentAddEditInfo.BinNumber = "";
			this.ItemCollectionStudentAddEditInfo.ScanPersonalItemDesc = "";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPersonalItemClassChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPersonalItemClassChange(e: any) {
		//
		//	Select Default PersonalItemClass
		//
 		this.lstScanPersonalItemClass.forEach((item) => {
			if (item.ScanPersonalItemClassID == this.SelectedScanPersonalItemClass.ScanPersonalItemClassID) {
				this.SelectedScanPersonalItemClass = item;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onScanPersonalItemConditionChange
	//
	//-----------------------------------------------------------------------------------------------------
	onScanPersonalItemConditionChange(e: any) {
		//
		//	Select Default PersonalItemCondition
		//
		this.lstScanPersonalItemCondition.forEach((item) => {
			if (item.ScanPersonalItemConditionID == this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID) {
				this.SelectedScanPersonalItemCondition = item;
			}
		});	
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		//
		//	Validate
		//
		if (this.SelectedScanPersonalItemClass.ScanPersonalItemClassID < 1) {
			this.ErrorMessage = "Invalid Class.";
			return;
		}

		if (this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID < 1) {
			this.ErrorMessage = "Invalid Condition.";
			return;
		}

		if (this.isEditMode == false && this.SelectedPerson.PersonID < 1) 
		{
			this.ErrorMessage = "Please select a Student.";
			return;
		}

		//
		//	Validate Passed / Do the Update
		//
		let parm: wsItemCollectionStudentAddEditUpdateInfoParm = 
		{
			ScanPersonalItemID: "",
			PersonID: -1,
			Log_PersonID: -1,
			ScanPersonalItemClassID: -1,
			ScanPersonalItemConditionID: -1,
			BinNumber: "",
			ScanPersonalItemDesc: ""
		};

		if (this.isEditMode == true) 
		{
			parm.ScanPersonalItemID = this.ItemCollectionStudentAddEditInfo.ScanPersonalItemID;
			parm.PersonID = this.ItemCollectionStudentAddEditInfo.PersonID;
			parm.Log_PersonID = this.dialogConfig.data.Log_PersonID;
			parm.ScanPersonalItemClassID = this.SelectedScanPersonalItemClass.ScanPersonalItemClassID;
			parm.ScanPersonalItemConditionID = this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID;
			parm.BinNumber = this.ItemCollectionStudentAddEditInfo.BinNumber;
			parm.ScanPersonalItemDesc = this.ItemCollectionStudentAddEditInfo.ScanPersonalItemDesc;
		}
		else
		{
			parm.ScanPersonalItemID = "";
			parm.PersonID = this.SelectedPerson.PersonID;		// From Person Selector
			parm.Log_PersonID = this.ItemCollectionStudentAddEditInfo.Log_PersonID;
			parm.ScanPersonalItemClassID = this.SelectedScanPersonalItemClass.ScanPersonalItemClassID;
			parm.ScanPersonalItemConditionID = this.SelectedScanPersonalItemCondition.ScanPersonalItemConditionID;
			parm.BinNumber = this.ItemCollectionStudentAddEditInfo.BinNumber;
			parm.ScanPersonalItemDesc = this.ItemCollectionStudentAddEditInfo.ScanPersonalItemDesc;
		}

		this.isBusy = true;
		this.dataService.ItemCollectionStudentAddEditUpdate(parm).subscribe((data) => this.ItemCollectionStudentAddEditUpdate_Complete(data));		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStudentAddEditUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentAddEditUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
